const CLOSED_STATUS_VALUES = new Set(["completed", "canceled", "cancelled"])

const CLOSED_STATUS_NAMES = new Set([
	"done",
	"shipped",
	"released",
	"closed",
	"canceled",
	"cancelled",
	"duplicate",
	"declined",
	"rejected",
	"wont fix",
	"won't fix",
	"not planned",
])

/** True for an issue nobody is working on any more, by state type or status name. */
export function isClosedIssueStatus(
	status: string | null | undefined,
	statusName?: string | null,
): boolean {
	const normalized = status?.trim().toLowerCase()
	if (normalized && CLOSED_STATUS_VALUES.has(normalized)) return true

	const name = statusName?.trim().toLowerCase()
	return name != null && CLOSED_STATUS_NAMES.has(name)
}
